import {Component, OnInit} from '@angular/core';
import {TableService} from '../../services/table.service';
import {BinKeysService} from '../../services/bin-keys.service';
import {DatePipe} from '@angular/common';
import {EncryptionKeysLogsFilterCriteria} from '../../models/filter/encryption-keys-logs-filter-criteria';
import * as _ from 'lodash';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {SelectItem} from 'primeng/api';
import {EncryptionKeysLogs} from '../../models/encryptionKeysLogs';
import {BaseClientComponent} from '../base-client.component';

@Component({
  selector: 'app-encryption-keys-logs',
  templateUrl: './encryption-keys-logs.component.html',
  styleUrls: ['./encryption-keys-logs.component.scss']
})
export class EncryptionKeysLogsComponent extends BaseClientComponent implements OnInit {
  filteredEncryptionKeysLogs: EncryptionKeysLogs[] = [];
  userItems: SelectItem[] = [];
  actionItems: SelectItem[];
  companyItems: SelectItem[] = [];
  encryptionKeysLogs: EncryptionKeysLogs[];
  columns: any;
  encryptionKeysLogsFilterCriteria: EncryptionKeysLogsFilterCriteria;
  userChoicesFiltersDefaultCriteria = {
    'action': 'All',
    'company': null,
    'user': null,
    'dateFrom': null,
    'dateTo': null,
  };
  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultCriteria);

  constructor(public tableService: TableService,
              public authenticationService: AuthenticationService,
              private binKeyService: BinKeysService,
              private utilsService: UtilsService,
              public datePipe: DatePipe) {
    super();
    this.actionItems = [
      {label: 'All', value: 'All'},
      {label: 'Delete', value: 'delete'},
      {label: 'Download', value: 'download'},
      {label: 'Upload', value: 'upload'},
    ];
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getEncryptionKeysLogs();
      this.initializeColumnsForCommercialPopList();
    });
    this.subscriptions.push(response$);
    this.encryptionKeysLogsFilterCriteria = new EncryptionKeysLogsFilterCriteria(this.userChoicesActiveFilters);
  }

  filter() {
    this.filteredEncryptionKeysLogs = this.encryptionKeysLogs;
    if (this.encryptionKeysLogsFilterCriteria.action === 'All'
      && this.encryptionKeysLogsFilterCriteria.company === ''
      && this.encryptionKeysLogsFilterCriteria.user === null
      && !this.encryptionKeysLogsFilterCriteria.dateFrom
      && !this.encryptionKeysLogsFilterCriteria.dateTo) {
      this.filteredEncryptionKeysLogs = this.encryptionKeysLogs;
      return;
    }
    this.resetDataWithFromDate();
    this.resetDataWithToDate();
    this.setFilters();
    this.utilsService.saveUserData('encryptionKeysLogsFilter',
      {
        'action': this.encryptionKeysLogsFilterCriteria.action,
        'company': this.encryptionKeysLogsFilterCriteria.company,
        'user': this.encryptionKeysLogsFilterCriteria.user,
        'DateFrom': this.encryptionKeysLogsFilterCriteria.dateFrom,
        'DateTo': this.encryptionKeysLogsFilterCriteria.dateTo
      });
  }

  reset() {
    this.utilsService.saveUserData('encryptionKeysLogsFilter', this.userChoicesFiltersDefaultCriteria);
    this.encryptionKeysLogsFilterCriteria = new EncryptionKeysLogsFilterCriteria(this.userChoicesFiltersDefaultCriteria);
    this.filteredEncryptionKeysLogs = this.encryptionKeysLogs;
  }

  setCompaniesAndUsersList() {
    this.companyItems.push({label: '', value: null});
    this.companyItems = this.encryptionKeysLogs.map(encryptionKeyLog => ({
      label: encryptionKeyLog.companyName,
      value: encryptionKeyLog.companyName
    } as SelectItem));
    this.companyItems = this.companyItems.filter(
      (item, index, self) => self.findIndex(i => i.value === item.value) === index);
    this.companyItems.sort((selectItem1, selectItem2) => {
      if (selectItem1.label < selectItem2.label) {
        return -1;
      }
      if (selectItem1.label > selectItem2.label) {
        return 1;
      }
      return 0;
    });
    this.userItems.push({label: '', value: null});
    this.userItems = this.encryptionKeysLogs.map(encryptionKeyLog => ({
      label: encryptionKeyLog.userName,
      value: encryptionKeyLog.userName
    } as SelectItem));
    this.userItems = this.userItems.filter(
      (item, index, self) => self.findIndex(i => i.value === item.value) === index);
    this.userItems.sort((selectItem1, selectItem2) => {
      if (selectItem1.label < selectItem2.label) {
        return -1;
      }
      if (selectItem1.label > selectItem2.label) {
        return 1;
      }
      return 0;
    });
  }

  getEncryptionKeysLogs() {
    this.binKeyService.getEncryptionKeysLogs().subscribe(
      encryptionKeysLogs => {
        this.encryptionKeysLogs = encryptionKeysLogs.sort((a, b) => {
          return <any>new Date(b.date) - <any>new Date(a.date);
        });
        this.setCompaniesAndUsersList();
        this.filteredEncryptionKeysLogs = this.encryptionKeysLogs;
        this.utilsService.unlockUi();
      }
    );
  }

  getUserName(key) {
    if (!key.userName) {
      if (key.action === 'Delete') {
        key.userName = '';
      } else {
        key.userName = 'User was removed';
      }
    }
    return key.userName;
  }


  resetDataWithFromDate() {
    if (!this.encryptionKeysLogsFilterCriteria.dateFrom) {
      return;
    }
    this.filteredEncryptionKeysLogs =
      this.filteredEncryptionKeysLogs.filter(key => new Date(key.date) > new Date(this.encryptionKeysLogsFilterCriteria.dateFrom));

  }

  resetDataWithToDate() {
    if (!this.encryptionKeysLogsFilterCriteria.dateTo) {
      return;
    }
    this.filteredEncryptionKeysLogs =
      this.filteredEncryptionKeysLogs.filter(key => {
        const createdAt = new Date(key.date);
        const dateTo = new Date(this.encryptionKeysLogsFilterCriteria.dateTo);
        createdAt.setHours(0, 0, 0, 0);
        dateTo.setHours(0, 0, 0, 0);
        return createdAt <= dateTo;
      });
  }

  private filterByUser() {
    if (this.encryptionKeysLogsFilterCriteria.user === null) {
      return;
    }
    this.filteredEncryptionKeysLogs = this.filteredEncryptionKeysLogs.filter(keyEncryption => keyEncryption.userName === this.encryptionKeysLogsFilterCriteria.user);
  }

  private initializeColumnsForCommercialPopList() {
    this.columns = [
      {field: 'date', header: 'Date', sortDisabled: false},
      {field: 'logDescription', header: 'Log description', sortDisabled: true},
      {field: 'action', header: 'Action', sortDisabled: true},
      {field: 'User', header: 'User', sortDisabled: true},
      {field: 'companyName', header: 'Company', sortDisabled: true},
      {field: 'method', header: 'Method', sortDisabled: true}
    ];
  }

  private setFilters() {
    this.filterByCompany();
    this.filterByUser();
    this.filterByAction();
  }

  private filterByCompany() {
    if (this.encryptionKeysLogsFilterCriteria.company === '' || this.encryptionKeysLogsFilterCriteria.company === null) {
      return;
    }
    this.filteredEncryptionKeysLogs = this.filteredEncryptionKeysLogs.filter(keyEncryption =>
      keyEncryption.companyName.toLowerCase().includes(this.encryptionKeysLogsFilterCriteria.company.toLowerCase())
    );

  }

  private filterByAction() {
    if (this.encryptionKeysLogsFilterCriteria.action !== 'All') {
      if (this.encryptionKeysLogsFilterCriteria.action === 'Download') {
        this.filteredEncryptionKeysLogs = this.filteredEncryptionKeysLogs.filter(keyEncryption => keyEncryption.action === 'download');
      } else if (this.encryptionKeysLogsFilterCriteria.action === 'Upload') {
        this.filteredEncryptionKeysLogs = this.filteredEncryptionKeysLogs.filter(keyEncryption => keyEncryption.action === 'upload');
      } else {
        this.filteredEncryptionKeysLogs = this.filteredEncryptionKeysLogs.filter(keyEncryption => keyEncryption.action === 'Delete');
      }
    }
  }

}
